const initialState =
{
    loading: false,
    error: false,
    chartData: [],
    chartDataDeep: [],
    chartDataSec: [],
    dataInventoryAll:null,
    dataInventory:null,
    marca:"TODO",
    marcas:[{"id":0,"nombre":"GRUPO OPTIMA","descripcion":"","estatus":1,"marcaUnidades":[]},{"id":2,"nombre":"KIA","descripcion":"","estatus":1,"marcaUnidades":[{"id":1,"nombre":"","descripcion":"KIA TIJUANA","codigo":"030303","marca_id":2,"unidad_id":1,"estatus":1,"unidad":{"id":1,"nombre":"TIJUANA","descripcion":"","estatus":1}},{"id":2,"nombre":"","descripcion":"KIA MEXICALI","codigo":"030304","marca_id":2,"unidad_id":2,"estatus":1,"unidad":{"id":2,"nombre":"MEXICALI","descripcion":"","estatus":1}},{"id":9,"nombre":"","descripcion":"KIA ENSENADA","codigo":"030311","marca_id":2,"unidad_id":3,"estatus":1,"unidad":{"id":3,"nombre":"ENSENADA","descripcion":"","estatus":1}}]},{"id":1,"nombre":"HONDA","descripcion":"","estatus":1,"marcaUnidades":[{"id":3,"nombre":"","descripcion":"HONDA TIJUANA","codigo":"030305","marca_id":1,"unidad_id":1,"estatus":1,"unidad":{"id":1,"nombre":"TIJUANA","descripcion":"","estatus":1}},{"id":4,"nombre":"","descripcion":"HONDA MEXICALI","codigo":"030306","marca_id":1,"unidad_id":2,"estatus":1,"unidad":{"id":2,"nombre":"MEXICALI","descripcion":"","estatus":1}},{"id":5,"nombre":"","descripcion":"HONDA ENSENADA","codigo":"030307","marca_id":1,"unidad_id":3,"estatus":1,"unidad":{"id":3,"nombre":"ENSENADA","descripcion":"","estatus":1}}]},{"id":3,"nombre":"HONDA MOTOS","descripcion":"","estatus":1,"marcaUnidades":[{"id":6,"nombre":"","descripcion":"HONDA MOTOS TIJUANA","codigo":"030308","marca_id":3,"unidad_id":1,"estatus":1,"unidad":{"id":1,"nombre":"TIJUANA","descripcion":"","estatus":1}},{"id":8,"nombre":"","descripcion":"HONDA MOTOS MEXICALI","codigo":"030310","marca_id":3,"unidad_id":2,"estatus":1,"unidad":{"id":2,"nombre":"MEXICALI","descripcion":"","estatus":1}}]}],
    colorArray:['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
          '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
          '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
          '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
          '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
          '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
          '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
          '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
          '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
          '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
}

export default (state = initialState, action) => {

    switch (action.type) {
        case "REQUEST_FAILURE":
            return { ...state, chartData: action.payload, loading: false, error: true };
        case "LOADING":
            return { ...state, chartData: action.payload, loading: true, error: false };
        case "CHART_DATA":
            return { ...state, chartData: action.payload,  error: false };
        case "CHART_DATA_INVENTORY":
            return { ...state, dataInventory: action.payload.dataInventory,dataInventoryAll:action.payload.dataInventoryAll, loading: false, error: false };
        case "CHART_DATA_SEC":
            return { ...state, chartDataSec: action.payload,  error: false };
        case "CHART_DATA_DEEP":
            return { ...state, chartDataDeep: action.payload,  error: false };

        default:
    }
    return state;
}